import workspaceQuery from 'graphql/queries/customer/CustomerLetterHistoryWorkspaceQuery.graphql';
import fragment from 'graphql/fragments/customer/CustomerLetterHistoryFragment.graphql';

const CustomerLetterHistory = {
  type: 'CustomerLetterHistory',
  title: 'Customer Letter History',
  formUrl: '/Customer/CustomerLetterHistory/Details/',
  formTitle: 'Customer Letter History',
  workspaceUrl: '/Customer/CustomerLetterHistory/Workspace/',
  workspace: workspaceQuery,
  fragment,
};

export default CustomerLetterHistory;
